
import './spinner.styles.css';

const Spinner = () => {
  return (
    <div className="SpinnerOverlay">
      <div className="SpinnerContainer" />
    </div>
  );
};

export default Spinner;
